import $ from "jquery";

const toggle = $(".social-sharer-toggle-img");

const socialTabList = () => {
  const dropdown = $(".social-icons--desktop");
  const focusableEls = dropdown.find("[href]");
  const lastFocusableEls = focusableEls.last()[0];
  const heading = $(".social-sharer-toggle");

  $(lastFocusableEls).focusout(() => {
    heading.focus();
  });
};

const openShareLinks = () => {
  if (!toggle.parent().hasClass("social-sharer-toggle--active")) {
    toggle.parent().addClass("social-sharer-toggle--active");
    toggle.parent().attr("aria-expanded", "true");
    $(".social-icons").addClass("social-icons--active");
    $(".social-icons").attr("aria-hidden", "false");
  } else {
    toggle.parent().removeClass("social-sharer-toggle--active");
    toggle.parent().attr("aria-expanded", "false");
    $(".social-icons").removeClass("social-icons--active");
    $(".social-icons").attr("aria-hidden", "true");
  }
};

toggle.on("click", () => {
  openShareLinks();
  socialTabList();
});

$(document).on("keypress", e => {
  if (
    ($(".social-sharer-toggle").is(":focus") && e.which === 13) ||
    ($(".social-sharer-toggle").is(":focus") && e.which === 32)
  ) {
    e.preventDefault();

    openShareLinks();
    socialTabList();
  }
});

$(document).mouseup(e => {
  if (!e.target.classList.contains("social-sharer-toggle-img")) {
    if ($(".social-sharer-toggle").hasClass("social-sharer-toggle--active")) {
      const container = $(".social-icons--active");

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("social-icons--active");
        $(".social-sharer-toggle").removeClass("social-sharer-toggle--active");
        $(".social-icons").attr("aria-hidden", "true");
        toggle.parent().attr("aria-expaned", "false");
      }
    }
  }
});
